<div class="gallery-container">
    <div class="gallery-title">{{'Navbar_Item_Gallery' | transformText}}</div>
    <gallery class="images-container"
            [flexBorderSize]="20" 
            [flexImageSize]="10"
            [maxRowsPerPage]="2">
    </gallery>
</div>